export type SavedSelection = {
  html: string;
  text: string | null;
};

const SK_LAST_SELECTION = "lastSelection";

export function saveSelection(categoryName: string, htmlText: string, text: string | null): void {
  const entry: SavedSelection = {
    html: htmlText,
    text: text,
  };
  sessionStorage.setItem(`${categoryName}_${SK_LAST_SELECTION}`, JSON.stringify(entry));
}

export function clearSavedSelection(categoryName: string): void {
  sessionStorage.removeItem(`${categoryName}_${SK_LAST_SELECTION}`);
}

export function getSavedSelection(categoryName: string): SavedSelection | null {
  const raw = sessionStorage.getItem(`${categoryName}_${SK_LAST_SELECTION}`);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SavedSelection;
  } catch {
    return null;
  }
}

// ####################### Generic Session Storage Utils ######################

export function saveItem(name: string, item: any): void {
  const raw = JSON.stringify(item);
  sessionStorage.setItem(name, raw);
}

export function getItem<T>(name: string): T | null {
  const raw = sessionStorage.getItem(name);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function removeItem(name: string): void {
  sessionStorage.removeItem(name);
}
